interface HeaderItemProps {
  hideLabel?: boolean;
  label: string;
  value?: string;
}

export function HeaderItem({ hideLabel = false, label, value }: HeaderItemProps) {
  return (
    <span key={label} className="flex border-r-2 px-2 py-1">
      {!hideLabel && <span data-testid={`patient-${label}`}>{`${label}:`}</span>}
      <div className="px-1" data-testid={`patient-${label}-value`}>
        {value}
      </div>
    </span>
  );
}
